import apiService from "./apiService";
import AppConstants from "@/appConstants";
import localStorageHelper from "@/helpers/local-storage-helper";
import EventEmitter from "events";
import router from "@/router/index";
import store from "@/store";

class AuthService extends EventEmitter {

  loginData = null;
  isLoggedIn = false;

  fakeLogin(email) {
    console.log('fake login');
    return new Promise(resolve => {
      resolve({
        username: 'Username teste',
        auth: 'auth',
        email: email,
        origins: [
          { id: 1, name: "Agência CMA" },
          { id: 2, name: "Agência CMA APP" },
          { id: 3, name: "Agência LATAM" }
        ], 
        profile: { id: 1, name: 'ADMIN'},
        token: "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbkBjbWEuY29tLmJyIiwiYXV0IjpbeyJhdXRob3JpdHkiOiJST0xFX01FTlVfUFVCTElTSF9TRU5EIn1dLCJ1c2VyX2FnZW5jeSI6IltdIiwidXNlcl9jb2RlIjoyLCJ1c2VyX3RvcGljcyI6Ilt7XCJ0b3BfSW50VG9waWNcIjogMSwgXCJ0b3BfQ2hhVG9waWNcIjogXCJBR0VOQ0lBQ01BXCJ9LHtcInRvcF9JbnRUb3BpY1wiOiAyLCBcInRvcF9DaGFUb3BpY1wiOiBcIlNBRlJBU0NPTk5FQ1RcIn1dIiwidXNlcl9uYW1lIjoiQWRtaW4iLCJjcmVhdGVkIjoxNTcyMzY3NTg0ODI0LCJ1c2VyX3Byb2ZpbGUiOiJBRE1JTiIsImV4cCI6MTU3Mjk3MjM4NH0.uaZie-mnuJqBwYVRA6FRkL98tp9HUyACCjdrDq-7V4E-RCtJrCYXaK5n5kCLEfmfp1b8N8wCsvnRZ3oGOwY-Xw"
      });
    });
  }

  login(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_AUTH_LOGIN, form, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  loginTwoFactorAuth(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_AUTH_LOGIN_TWO_FACTOR_AUTH, form, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
  validateTwoFactorAuthToken(form, params) {
    return new Promise((resolve, reject) => {
      apiService.post(AppConstants.URL_AUTH_LOGIN_VALIDATE_TOKEN, form, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  successLogin(authResult) {
    this.isLoggedIn = true;
    
    this.loginData = {
      username: authResult.username,
      token: authResult.token,
      auth: authResult.auth,
      email: authResult.email,
      origin: authResult.origins,
      profile: authResult.profile,
      theme: authResult.theme,
      locale: authResult.locale,
      sendNewsConfig: authResult.sendNewsConfig,
      avatar: authResult.image_path,
      agency: authResult.agency,
      subjectViewType: authResult.subjectViewType,
      channels: authResult.channels
    };

    // console.warn(this.loginData);

    localStorageHelper.saveData(AppConstants.LOCAL_STORAGE_HAS_LOGGED_IN, true);
    localStorageHelper.setCurrentUser(this.loginData);
    store.dispatch("auth/successLogin", this.loginData);
    store.dispatch("auth/setUserCore", authResult.userCore);

    // localStorageHelper.saveData(AppConstants.LOCAL_STORAGE_LOCALE, auth.language);

    // Listener of this event login has been in auth.js
    this.emit(AppConstants.EVENT_LOGIN, {
      loggedIn: true,
      loginData: this.loginData
    });

    return this.loginData;
  }

  isAuthenticated() {
    return localStorageHelper.getUserHasLoggedIn() === 'true';
  }

  logout() {
    this.isLoggedIn = false;
    this.loginData = null;

    store.dispatch('report/clearTabs');
    store.dispatch('auth/logout');
    router.push({ path: AppConstants.NAVIGATION_PAGE_LOGIN });
  }

  /* eslint-disable */
  changePassword_updateData(data) {
    const currentUser = store.state.auth.currentUser;
    currentUser.token = data.token;
    currentUser.auth = data.auth;
    store.dispatch('auth/updateCurrentUser', currentUser);
  }

  getConfig(url, auth) {
    return new Promise((resolve, reject) => {
      apiService.getWithBasicAuth(url, auth)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}

export default new AuthService();
